/**
 * @fileoverview Destino da conversa na aba "Conclusão" do editor de triagem:
 * fila e usuário, cada um opcional, com as regras do modal de transferência.
 * Com um usuário, a lista de filas mostra só as dele e o vazio vira "Sem fila";
 * sem usuário, o vazio mantém a fila em que a conversa está.
 */

import React from "react";
import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../../../translate/i18n";
import ModernSelect from "../../../../components/ModernSelect";
import useStyles from "./styles";

const d = (key) => i18n.t(`triage.manager.editor.completion.destination.${key}`);

const DestinationFields = ({ queueId, userId, onChange, queues, users, removed = false }) => {
  const classes = useStyles();
  const pessoa = users.find((u) => String(u.id) === String(userId)) || null;
  const filas = pessoa ? queues.filter((q) => pessoa.queueIds.includes(q.id)) : queues;

  // Pessoa nova: a fila que não é dela sai (como no modal de transferência).
  const escolherPessoa = (id) => {
    const nova = users.find((u) => String(u.id) === String(id));
    const fica = queueId === "" || !nova || nova.queueIds.some((q) => String(q) === String(queueId));
    onChange({ userId: id, queueId: fica ? queueId : "" });
  };

  const select = (props) => (
    <ModernSelect className={classes.field} size="small" fullWidth InputLabelProps={{ shrink: true }} displayEmpty {...props} />
  );

  return (
    <div>
      <div className={classes.grid2}>
        {select({
          label: d("queue"),
          value: queueId,
          onChange: (ev) => onChange({ userId, queueId: ev.target.value }),
          children: [
            <MenuItem key="none" value="">
              <em>{pessoa ? d("queueNone") : d("queueKeep")}</em>
            </MenuItem>,
            ...filas.map((q) => (
              <MenuItem key={q.id} value={q.id}>
                {q.name}
              </MenuItem>
            )),
          ],
        })}
        {select({
          label: d("user"),
          value: userId,
          onChange: (ev) => escolherPessoa(ev.target.value),
          children: [
            <MenuItem key="none" value="">
              <em>{d("userNone")}</em>
            </MenuItem>,
            ...users.map((u) => (
              <MenuItem key={u.id} value={u.id}>
                {u.name}
              </MenuItem>
            )),
          ],
        })}
      </div>
      {removed && <div className={classes.warnText}>{d("removed")}</div>}
    </div>
  );
};

export default DestinationFields;
